<template>
  <div :style="containerStyle">
    <slot></slot>
  </div>
</template>
<script lang="ts" setup>
import { computed } from "vue"

const props = withDefaults(
  defineProps<{
    vGap?: number
    hGap?: number
    vertical?: boolean
    justify?: "start" | "center" | "end" | "space-between" | "space-around"
    alignContent?: "start" | "center" | "end"
    alignItems?: "start" | "center" | "end" | "baseline"
    wrap?: boolean
    full?: boolean
  }>(),
  {
    vGap: 8,
    hGap: 8,
    vertical: false,
    justify: "start",
    alignContent: "start",
    alignItems: "start",
    wrap: false,
    full: false,
  }
)

const containerStyle = computed(() => {
  return {
    display: "flex",
    "flex-direction": props.vertical ? "column" : "row",
    "flex-wrap": props.wrap ? "wrap" : "nowrap",
    "justify-content": props.justify,
    "align-content": props.alignContent,
    "align-items": props.alignItems,
    gap: `${props.vGap}px ${props.hGap}px`,
    width: props.full ? "100%" : undefined,
  } as any
})
</script>
<style scoped></style>
